import React from 'react';
const { useState, useEffect } = React;

// After opening the full card (or the company, or a quote) from Hoy's follow-up panel: a clear way back to that
// follow-up. It reopens the panel over Hoy; nothing was saved by leaving. Only a convenience of this browser tab.
export default function ReturnToFollowup({ page }) {
  const [back, setBack] = useState(null);
  useEffect(() => { try { setBack(JSON.parse(sessionStorage.getItem('oike_followup_return') || 'null')); } catch { setBack(null); } }, [page]);
  if (!back?.stakeholderId || page === 'myspace') return null;
  const go = () => {
    try { sessionStorage.removeItem('oike_followup_return'); sessionStorage.setItem('oike_followup_reopen', JSON.stringify({ stakeholderId: back.stakeholderId })); } catch { /* still navigates */ }
    window.dispatchEvent(new CustomEvent('oike:navigate', { detail: { page: 'myspace' } }));
  };
  const dismiss = () => { try { sessionStorage.removeItem('oike_followup_return'); } catch { /* ignore */ } setBack(null); };
  return (
    <div role="region" aria-label="Volver al seguimiento" style={{ position: 'sticky', top: 0, zIndex: 50, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', background: 'var(--teal-dim, rgba(91,191,181,0.15))', border: '1px solid var(--globant-green)', borderRadius: 10, padding: '8px 12px', margin: '0 0 10px', fontSize: 13 }}>
      <button type="button" className="action-btn btn-primary" style={{ fontSize: 12 }} onClick={go}>← Volver al seguimiento{back.name ? ` de ${back.name}` : ''} en Hoy</button>
      <span style={{ fontSize: 12, color: 'var(--globant-muted)', flex: '1 1 200px' }}>Lo que registres aquí queda igual; el panel se vuelve a abrir.</span>
      <button type="button" className="action-btn" style={{ fontSize: 11 }} onClick={dismiss}>Ocultar</button>
    </div>
  );
}
